import React from "react";

const Loader = ({ text = "Загрузка...", size = "medium" }) => {
  const sizeClasses = {
    small: "h-4 w-4",
    medium: "h-8 w-8",
    large: "h-12 w-12"
  };

  return (
    <div className="flex items-center justify-center p-4">
      <div className="text-center">
        <div className={`animate-spin rounded-full border-b-2 border-blue-500 mx-auto ${sizeClasses[size]}`}></div>
        {text && <div className="mt-2 text-gray-600">{text}</div>}
      </div>
    </div>
  );
};

export default Loader; 